/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { PremiumCalculatorMessage } from "../../../messages";
import fhpCalcConfig from "../../../config/fhpCalculator.config.json";
import Pricing, {
  FormatMoney,
  getAllInfoByISO,
} from "@vlinder-web/pricing-powerpuff-module-react";

export const triggerInsuranceProviderCharge = (lifeCycle: any) => {
  const message = lifeCycle?.fsm?.message as PremiumCalculatorMessage;
  // @ts-ignore
  const countryFound = fhpCalcConfig[message.country];
  if (!countryFound) {
    throw Error(`unsupported country ${message.country} for this product`);
  }
  const pricing = Pricing.make({
    model: countryFound.insuranceProviderCharge?.model,
    tiers: countryFound.insuranceProviderCharge?.tiers,
  });
  const format = new FormatMoney({ decimals: 2 });
  const price = pricing.price(message.coverage);
  message.insuranceProviderCharge = {
    raw: price,
    formatted: format.from(price, {
      symbol: getAllInfoByISO(message.country)?.symbol,
    }),
  };
  return true;
};
